<app-tabla
  [totalCount]="totalCount"
  [datos]="activos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [crear]="botonCrear"
  [exportar]="[botonExportarExcel, botonSoflex]"
></app-tabla>
